import { FormKey } from '../../enums/formKey';
import { StepKey } from '../../enums/stepKey';
import { ApplianceFormData } from '../../models/form/appliance';
import { ApplianceModel } from '../../models/services/api/queryModelNumber';

export const getFormApplianceName = (
  formData: ApplianceFormData,
  applianceModels: ApplianceModel[] | undefined,
): string | undefined => {
  const formItemTypeCode = formData[StepKey.APPLIANCE_DETAILS]?.[FormKey.ITEM_CATEGORY];
  return applianceModels?.find((model) => model.itemTypeCode === formItemTypeCode)?.applianceName;
};
